export enum ClientType {
  Mock,
  Api,
}

export const ClientTypeMap = new Map<string, ClientType>([
  ['mock', ClientType.Mock],
  ['api', ClientType.Api],
])

export interface ClientConfig {
  clientType: ClientType
  address: string
}

interface Clients {
  bff: ClientConfig
  ptv: ClientConfig
}
export interface EnvironmentConfig {
  userpoolId: string
  appClientId: string
  clients: Clients
  environment: string
  mixpanelToken?: string // intentionally optional as no desire for tracking on localhost
  mockAuth?: boolean
  plannedMaintenance?: boolean
}

export const getEnvironmentConfig = (): EnvironmentConfig => {
  const userpoolId = process.env.NEXT_PUBLIC_USERPOOL_ID
  const appClientId = process.env.NEXT_PUBLIC_APP_CLIENT_ID
  const clientTypeEnv = process.env.NEXT_PUBLIC_CLIENT_TYPE
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT
  const mixpanelToken = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN
  const mockAuth = !!process.env.NEXT_PUBLIC_MOCK_AUTH
  const plannedMaintenance = process.env.NEXT_PUBLIC_PLANNED_MAINTENANCE === 'true'
  const bffAddress = process.env.NEXT_PUBLIC_CLIENT_ADDRESS
  const ptvAddress = process.env.NEXT_PUBLIC_CLIENT_ADDRESS_PTV

  if (userpoolId === undefined) {
    throw new Error('userpoolId not defined. ENV var NEXT_PUBLIC_USERPOOL_ID')
  }

  if (appClientId === undefined) {
    throw new Error('appClientId not defined. ENV var NEXT_PUBLIC_APP_CLIENT_ID')
  }

  if (clientTypeEnv === undefined) {
    throw new Error('clientType not defined. ENV var NEXT_PUBLIC_CLIENT_TYPE')
  }

  const clientType = ClientTypeMap.get(clientTypeEnv)

  if (clientType === undefined) {
    throw new Error('unknown client type: should be mock or api')
  }

  if (environment === undefined) {
    throw new Error('environment not defined. ENV var NEXT_PUBLIC_ENVIRONMENT')
  }

  if (bffAddress === undefined) {
    throw new Error('bffAddress not defined. ENV var NEXT_PUBLIC_CLIENT_ADDRESS')
  }

  if (ptvAddress === undefined) {
    throw new Error('ptvAddress not defined. ENV var NEXT_PUBLIC_CLIENT_ADDRESS_PTV')
  }

  const clients: Clients = {
    bff: {
      address: bffAddress,
      clientType,
    },
    ptv: {
      address: ptvAddress,
      clientType,
    },
  }
  return {
    userpoolId,
    appClientId,
    clients,
    environment,
    mixpanelToken,
    mockAuth,
    plannedMaintenance,
  }
}
